// AppShell — the persistent frame around every authenticated page.
//
//   ┌───────────── TopBar ─────────────┐
//   │                                  │
//   ├──────────┬───────────────────────┤
//   │ Sidebar  │     <main>            │
//   │          │     <Outlet />        │
//   │          │                       │
//   └──────────┴───────────────────────┘
//
// ToastContainer is mounted at the AppShell level so it overlays every page.

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { ToastContainer } from '../ui/Toast/Toast';
import { initErrorReporter } from '../../lib/errorReporter';
import styles from './AppShell.module.css';

export function AppShell() {
  // Wire the client error reporter once we are inside an authenticated
  // shell. The module-level guard inside initErrorReporter makes this
  // idempotent if the shell remounts.
  useEffect(() => {
    initErrorReporter({ realm: 'tenant' });
  }, []);

  return (
    <div className={styles.shell}>
      <div data-print-hide>
        <TopBar />
      </div>
      <div className={styles.body}>
        <div data-print-hide>
          <Sidebar />
        </div>
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      <div data-print-hide>
        <ToastContainer />
      </div>
    </div>
  );
}
